module.exports = __webpack_public_path__ + "img/s23.1c838993.png";